var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'calendar-input transition-input',
    _vm.value && 'filled',
    _vm.error && 'error',
    _vm.disabled && 'disabled',
    _vm.alignRight && 'position-right',
  ]},[_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"input-wrapper"},[_c('Datepicker',{ref:"datePicker",attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"monday-first":"","disabled":_vm.disabled,"calendar-class":"calendar","disabledDates":_vm.disabledDates,"full-month-name":"","language":_vm.translations,"open-date":_vm.openDate},on:{"selected":function($event){return _vm.$emit('update:value', $event)},"closed":function($event){return _vm.$emit('blur')}}}),_c('FontIcon',{staticClass:"calendar-icon",attrs:{"name":"ui_calendar"}})],1),_c('InputError',{attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }